
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface PostCancelLinesState  {
    isLoading: boolean,
    data: any,
    error: string | null,
}

const initialPostCancelLinesState: PostCancelLinesState = {
    isLoading: false,
    data: null,
    error: null
};

// Create Immer reducer
const postCancelLinesReducer = createTypedReducerWithImmer(initialPostCancelLinesState, {
    // Start loading
    "CancelLines/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "CancelLines/PopulateResult": (draft, action: { data: any }) => {
        draft.data = action.data;
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "CancelLines/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "CancelLines/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).postCancelLinesDetail = postCancelLinesReducer;

// Define type for action usage
type PostCancelLinesReducers = {
    postCancelLinesDetail: typeof postCancelLinesReducer;
};

export type PostCancelLinesActions = Parameters<PostCancelLinesReducers[keyof PostCancelLinesReducers]>[1] | AnyAction;
